import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

type Props = {
	title: string;
	time: string;
	className?: string;
	key?: string;
};

export function ActivityPill({ title, time, className, ...rest }: Props): JSX.Element {
	return (
		<div
			className={cn(
				'inline-flex h-12 items-center gap-1 rounded-medium bg-fill-accent-primary-weaker px-[11px] py-2',
				className,
			)}
			{...rest}
		>
			<Text data-nosnippet variant="body" size="x-small">
				{title}
			</Text>
			<Text variant="body" size="x-small">
				•
			</Text>
			<Text variant="body" size="x-small">
				{time}
			</Text>
		</div>
	);
}
